import { __decorate } from "tslib";
import { AutoEncoder, field, StringDecoder } from "@simonbackx/simple-encoding";
export class RichText extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.html = "";
        this.text = "";
    }
    toString() {
        return this.text;
    }
}
__decorate([
    field({ decoder: StringDecoder })
], RichText.prototype, "html", void 0);
__decorate([
    field({ decoder: StringDecoder })
], RichText.prototype, "text", void 0);
//# sourceMappingURL=RichText.js.map